import { useState } from 'react'
import { Box } from '@mui/material'
import { ChevronDown20Regular, ChevronRight20Regular } from '@/components/Icon'
import { formatWorkedForLabel } from './formatWorkedForLabel.js'
import ResponseStatusBadge from './ResponseStatusBadge.jsx'
import styles from './AIResponseLog.module.scss'

export default function StepHeader({
  durationMs,
  actionName,
  status,
  stream,
  defaultExpanded = false,
  expanded: controlledExpanded,
  onToggle,
  interactive = true,
}) {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded)
  const expanded = controlledExpanded ?? internalExpanded

  const handleClick = () => {
    if (!interactive) return
    if (onToggle) onToggle()
    else setInternalExpanded((v) => !v)
  }

  const isThinking = stream?.headerMode === 'thinking'
  const durationLabel = !isThinking && durationMs != null ? formatWorkedForLabel(durationMs) : null

  return (
    <button
      type="button"
      className={styles.stepHeader}
      onClick={handleClick}
      aria-expanded={expanded}
      disabled={!interactive}
    >
      <Box component="span" className={styles.chevron} aria-hidden>
        {expanded ? <ChevronDown20Regular /> : <ChevronRight20Regular />}
      </Box>
      <span className={styles.stepHeaderLabel}>
        {isThinking ? 'Thinking' : `${durationLabel ? `${durationLabel} · ` : ''}${actionName}`}
      </span>
      {status && status !== 'ok' ? <ResponseStatusBadge status={status} /> : null}
    </button>
  )
}
